import { BuildInfoContainer } from '../components/BuildInfoContainer/BuildInfoContainer';
import { format, isValid } from 'date-fns';
import {
  getCalculatorUrl,
  getProcessEnvUrl,
  getSelectedDevEnv,
  isEnvSwitcherEnabled,
} from './getUrl';
import { useMemo } from 'react';
import EnvSwitcher from './EnvSwitcher/EnvSwitcher';

export default function BuildInfo() {
  const buildEnv = process.env.REACT_APP_ENV as string;

  const items = useMemo(() => {
    const result = [];

    const buildDateTimeString = process.env.REACT_APP_BUILD_DATETIME_ISO8601;
    const isValidDate = isValid(buildDateTimeString);

    if (isValidDate && buildDateTimeString) {
      const date = new Date(buildDateTimeString);
      const formattedDate = format(date, 'iii MMM do yyyy HH:mm');
      result.push({
        key: 'built',
        value: formattedDate,
      });
    }

    if (buildEnv) {
      result.push({
        key: 'build env',
        value: buildEnv,
      });
    }

    const repoUrl = process.env.REACT_APP_GIT_URL;

    if (repoUrl) {
      result.push({
        key: 'repo',
        value: `<a href="${repoUrl}" target="_blank" rel="noopener">repository URL</a>`,
      });
    }

    const branch = process.env.REACT_APP_GIT_BRANCH;

    if (branch) {
      result.push({
        key: 'branch',
        value: branch,
      });
    }

    const commit = process.env.REACT_APP_GIT_COMMIT;

    if (commit) {
      result.push({
        key: 'commit',
        value: commit,
      });
    }

    const buildUrl = process.env.REACT_APP_BUILD_URL;

    if (buildUrl) {
      result.push({
        key: 'pipeline',
        value: `<a href="${buildUrl}" target="_blank" rel="noopener">build URL</a>`,
      });
    }

    const colaUrl = getProcessEnvUrl('COLA_URL');
    const webApiUrl = getProcessEnvUrl('WEB_API');
    const landingPageUrl = getCalculatorUrl();
    const vivusRegistrationUrl = getProcessEnvUrl('VIVUS_REGISTRATION_URL');
    const vivusonlineRegistrationUrl = getProcessEnvUrl(
      'VIVUSONLINE_REGISTRATION_URL',
    );

    if (
      [
        colaUrl,
        webApiUrl,
        landingPageUrl,
        vivusRegistrationUrl,
        vivusonlineRegistrationUrl,
      ].some((i) => !!i)
    ) {
      const urls = [];

      if (colaUrl) {
        urls.push(
          `<a href="${colaUrl}" target="_blank" rel="noopener">COLA</a>`,
        );
      }

      if (webApiUrl) {
        urls.push(
          `<a href="${webApiUrl}" target="_blank" rel="noopener">WebAPI</a>`,
        );
      }

      if (landingPageUrl) {
        urls.push(
          `<a href="${landingPageUrl}" target="_blank" rel="noopener">Account</a>`,
        );
      }

      if (vivusRegistrationUrl) {
        urls.push(
          `<a href="${vivusRegistrationUrl}" target="_blank" rel="noopener">Registration&nbsp;Vivus</a>`,
        );
      }

      if (vivusonlineRegistrationUrl) {
        urls.push(
          `<a href="${vivusonlineRegistrationUrl}" target="_blank" rel="noopener">Registration&nbsp;Vivusonline</a>`,
        );
      }

      result.push({
        key: 'URLs',
        value: urls.join(', '),
      });
    }

    return result;
  }, []);

  return (
    <BuildInfoContainer
      items={items}
      component={isEnvSwitcherEnabled(buildEnv) ? <EnvSwitcher /> : null}
      selectedEnv={
        isEnvSwitcherEnabled(buildEnv) ? getSelectedDevEnv() : undefined
      }
    />
  );
}
